import React, { createContext, useContext, useEffect, useMemo, useState } from 'react'
import { useMap, useMapEvent } from 'react-leaflet'
import { IPosition } from '../../../../generated-types'
import { getMooringCageLabelFontSize } from './utils'

const CageLabelFontSizeContext = createContext<number | null>(null)

export const CageLabelFontSizeProvider: React.FC<{
  positions: IPosition[]
  children: React.ReactNode
}> = ({ positions, children }) => {
  const map = useMap()
  const [zoomLevel, setZoomLevel] = useState(Math.floor(map.getZoom()))

  useMapEvent('zoomend', event => {
    setZoomLevel(Math.floor(event.target.getZoom()))
  })

  useEffect(() => {
    setZoomLevel(Math.floor(map.getZoom()))
  }, [map])

  const sharedFontSize = useMemo(() => getMooringCageLabelFontSize(positions, zoomLevel), [positions, zoomLevel])

  return <CageLabelFontSizeContext.Provider value={sharedFontSize}>{children}</CageLabelFontSizeContext.Provider>
}

export const useCageLabelFontSize = () => useContext(CageLabelFontSizeContext)
